// Pay Attention Metadata.
import PayAttentionSVG from '../../../assets/images/Thoughts/PayAttention.svg';

const PayAttentionMetadata = {
  id: 'PayAttention',
  title: 'Pay Attention',
  description: 'The Currency of Existence',
  thumbnail: PayAttentionSVG,
  featured: true,
};

export default PayAttentionMetadata;
